import React from "react";
import * as ROUTES from "../../Router/venue_routes";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import { removeGroupFromProgramme } from "../../services/hotelGroupService/preferredProgrammesService";
import { AgencyBadge, CompanyBadge } from "../../ui/EDGEBadges";
import { ButtonPrimary } from "../Button";

// const getNameValue = programme => programme.agency ? programme.agency.name : programme.company?.name ?? null
function stringToHexColor(str) {
  let hash = 0;

  // Generate a hash code from the string
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert hash to 6-digit hex and ensure it’s valid
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += value.toString(16).padStart(2, "0");
  }

  return color;
}
const PreferredProgrammeHotelGroupsList = ({
  hotelGroups,
  isFetchingHotelGroups,
  isHotelGroupUser,
  canHaveCommercialDeals,
  // isHotelGroupAdmin,
  // isAgency,
  isCompany,
  token,
}) => {
  let removeFromGroup = (hotelGroup, programme) => {
    removeGroupFromProgramme(token, programme.id, hotelGroup.id).then(() => {
      window.location.reload();
    });
  };
  let tableData = (hotelGroup, programme, isCompany) => {
    const {agency, company} = programme;
    const borderColour = stringToHexColor(agency ? agency.name : company.name);
    let deal = hotelGroup.deals? hotelGroup.deals.filter(function (deal) {
       if(deal && deal.apply_to_agency_id && agency) {
         return agency.id === deal.apply_to_agency_id;
       }
       if(deal && deal.apply_to_company_id && company) {
         return company.id === deal.apply_to_company_id;
       }
    }).reduce(function(dealx,dealy) {
      if(dealx && dealy){
        return dealx.default_event_commission_percentage > dealy.default_event_commission_percentage ? dealx : dealy
      }
      if(dealx && !dealy){
        return dealx
      }
      if(!dealx && dealy){
        return dealy;
      }
      if(!dealx && !dealy)
      {
        return null;
      }
    },null) : null;
    return (
      <tr key={hotelGroup.id}>
        {isCompany ? null :
          <td style={{borderLeft: `5px solid ${borderColour}`}}>
            <div className="flex items-center">
              {/*{isAgency ? (*/}
              <Link
                title={`View ${agency ? 'Agency' : 'Company'} Preferred Programme `}
                to={ROUTES.FRONTEND.PREFERRED_PROGRAMMES.VIEW.replace(
                  ":id",
                  agency
                    ? agency?.preferred_programme_id
                    : company?.preferred_programme_id
                ).replace(":programme", "")}
                className={"text-black"}
              >
                {agency ? (
                  <>
                    <AgencyBadge />
                    {agency.name}
                  </>
                ) : null}
                {company && company.name ? (
                  <>
                    <CompanyBadge />
                    {company.name}
                  </>
                ) : null}
              </Link>
              {/*) :*/}
              {/*(*/}
              {/*  <Link*/}
              {/*    to={ROUTES.FRONTEND.PREFERRED_PROGRAMMES.VIEW.replace(*/}
              {/*      ":id",*/}
              {/*      company?.preferred_programme_id,*/}
              {/*    ).replace(":programme", programme.id)}*/}
              {/*    className={"text-black"}*/}
              {/*  >*/}
              {/*    {company.name}<DumbBadge title={'Company Preferred Programme'}>C</DumbBadge>*/}
              {/*  </Link>*/}
              {/*)}*/}
            </div>
        </td>
        }
        <td>
          <div className="flex items-center">
            <Link
              title={`View ${agency ? 'Agency' : 'Company'} Preferred Programme Details for ${hotelGroup?.name}`}
              to={
                isHotelGroupUser
                  ? ROUTES.FRONTEND.HOTEL_GROUPS_VENUE.SINGLE_VIEW.replace(
                      ":id",
                      hotelGroup.id
                    )
                  : ROUTES.FRONTEND.PREFERRED_PROGRAMMES.VIEW.replace(
                      ":id",
                      hotelGroup.id
                    ).replace(":programme", programme.id)
              }
              className={"text-black"}
            >
              {hotelGroup?.parentGroup
                ? hotelGroup?.parentGroup?.name + " > "
                : ""}
              {hotelGroup?.name}
            </Link>
          </div>
        </td>

        <td>
          <div className="flex items-center">
            {hotelGroup?.groupType ? hotelGroup.groupType?.name : "N/A"}
          </div>
        </td>
        {canHaveCommercialDeals ?
        deal ?
          <td>
            <span
              title={`${
                deal.default_event_commission_percentage
                  ? `${
                    deal.default_event_commission_percentage
                  }% commission applied on ${deal.commission_applied_on} (${
                    deal.commission_vat_inclusive ? "including" : "excluding"
                  } vat)`
                  : "No commission arrangement"
              }`}
            >
            {deal.default_event_commission_percentage ?? "-"}%
          </span>
        </td>
          : <td></td>
          : null
        }
        <td className="px-6 py-3 whitespace-nowrap">
          <div className="flex items-center">
            <div className="text-sm font-medium text-gray-900">
              <div className="flex items-center justify-center">
                <Link
                  title={`View ${agency ? 'Agency' : 'Company'} Preferred Programme Details for ${hotelGroup?.name}`}
                  to={ROUTES.FRONTEND.PREFERRED_PROGRAMMES.VIEW.replace(
                    ":id",
                    hotelGroup.id
                  ).replace(":programme", programme.id)}
                  className={"text-black"}
                >
                  <ButtonPrimary small>View</ButtonPrimary>
                </Link>
                <Link
                  title={'Manage Preferred Programme overrides'}
                  to={
                    isHotelGroupUser
                      ? ROUTES.FRONTEND.HOTEL_GROUPS_VENUE.SINGLE_VIEW.replace(
                          ":id",
                          hotelGroup.id
                        )
                      : ROUTES.FRONTEND.PREFERRED_PROGRAMMES.EDIT.replace(
                          ":id",
                          hotelGroup.id
                        ).replace(":programme", programme.id)
                  }
                  className={"text-black px-2"}
                >
                  <ButtonPrimary small>Edit</ButtonPrimary>
                </Link>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
    <table className="edge-table">
      <thead>
        <tr>
          {isCompany ? null :   <th>Preferred Programme of</th>}

          <th>Group</th>
          <th>Type</th>
          {canHaveCommercialDeals ? <th>Commission Deal</th> : null }

          <th>Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {isFetchingHotelGroups  ? (
          <tr><td colSpan={4}><Loading /></td></tr>
        ) : null }
        {hotelGroups.length > 0 &&
          hotelGroups.map(hotelGroup => {
            return hotelGroup?.programmes?.map(programme => {
              return tableData(
                hotelGroup,
                programme,
                isCompany
              );
            });
          })
        }
      </tbody>
      <tfoot>
      <tr><td colSpan={4}><p>To view the Preferred Program Event Data click on a Preferred Program or one of it's Groups above.</p></td></tr>
      </tfoot>
    </table>

    </>
  );
};

export default PreferredProgrammeHotelGroupsList;
